import React, { Component } from "react";

import BaptismImg from "../../assets/images/new_here/Baptism.jpg";

class BecomingAPartner extends Component {
	render() {
		return (
			<section>
				<header id="page-title">
					<div className="container">
						<h1>Becoming A Partner</h1>
					</div>
				</header>
				<section className="container">
					<img src={BaptismImg} style={{ float: "right" }} alt="" />
					<p>
						In his letter to the Philippians, Paul tells his readers that he ‘always prays with joy because of your
						partnership in the gospel from the first day until now’ (Phil 1:4-5). That’s what we are at CRCK: not
						members of a club, but partners together in the cause of the gospel. To reflect that, we have a formal
						‘partnership’ process, whereby people who want to officially commit themselves to the life and mission of
						our church sign a ‘covenant’ committing themselves to the basic aspects of our church life.
						<br />
						<br />
						If you would like to become a partner at CRCK, or would like some more information about it, please contact
						the office: (03) 6229 2268 or <a href="mailto:office@kingstoncrc.org.au">office@kingstoncrc.org.au</a>
					</p>
				</section>
			</section>
		);
	}
}

export default BecomingAPartner;
